var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7857 0.105469H2.20893C1.26607 0.105469 0.5 0.882255 0.5 1.83583V22.3751C0.5 23.3287 1.26607 24.1055 2.20893 24.1055H22.7857C23.7286 24.1055 24.5 23.3287 24.5 22.3751V1.83583C24.5 0.882255 23.7286 0.105469 22.7857 0.105469ZM7.75357 20.6769H4.19643V9.22333H7.75893V20.6769H7.75357ZM5.975 7.65904C4.83393 7.65904 3.9125 6.73225 3.9125 5.59654C3.9125 4.46083 4.83393 3.53404 5.975 3.53404C7.11071 3.53404 8.0375 4.46083 8.0375 5.59654C8.0375 6.73761 7.11607 7.65904 5.975 7.65904ZM21.0875 20.6769H17.5304V15.1055C17.5304 13.7769 17.5036 12.068 15.6821 12.068C13.8286 12.068 13.5446 13.5144 13.5446 15.009V20.6769H9.9875V9.22333H13.4V10.7876H13.4482C13.925 9.88761 15.0875 8.9394 16.8179 8.9394C20.4179 8.9394 21.0875 11.3126 21.0875 14.3983V20.6769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.878e6d2ee749c348b7eb8b5cdb8bde42.svg";
export { ForwardRef as ReactComponent };